import { useCallback, useEffect, useRef, useState } from "react";

type OpenCallback = (() => void) | null;

export function useExitEmail() {
  const [isOpen, setIsOpen] = useState(false);
  const callbackRef = useRef<OpenCallback>(null);

  const open = useCallback((onConfirm?: () => void) => {
    callbackRef.current = onConfirm ?? null;
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    callbackRef.current = null;
    setIsOpen(false);
  }, []);

  const confirm = useCallback(() => {
    const cb = callbackRef.current;
    callbackRef.current = null;
    setIsOpen(false);
    if (cb) cb();
  }, []);

  // Note: we intentionally do NOT register a global beforeunload handler here.
  // Registering a beforeunload handler causes the browser to show a native
  // confirmation dialog which prevents showing our themed modal for internal
  // navigation (Back button). We rely on history/popstate interception for
  // internal navigation and accept the browser native prompt only for tab
  // close/refresh where custom UI is not possible.

  return { isOpen, open, close, confirm } as const;
}
